module.exports = __webpack_public_path__ + "static/media/fire_sound.013ca95f.mp3";